// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + "-" + "b89e64ae53c11da3696a" + ".js";
};